import { useAuth } from "@/context/AuthContext";
import { ZLogo } from "@/components/ZLogo";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldCheck, Users, User } from "lucide-react";

const roleMeta = {
  admin: { label: "Amministratore", icon: ShieldCheck },
  manager: { label: "Capo Area", icon: Users },
  agent: { label: "Agente", icon: User },
};

export function Layout({ children }) {
  const { user, logout } = useAuth();
  const meta = roleMeta[user?.role] || roleMeta.agent;
  const RoleIcon = meta.icon;

  return (
    <div className="App min-h-screen bg-[#F5F9FF] text-[#0F1E33]">
      <header
        className="sticky top-0 z-50 border-b border-[#DCE7F5] backdrop-blur-xl"
        style={{ background: "rgba(245,249,255,0.85)" }}
        data-testid="app-header"
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <ZLogo size={44} />
            <div className="leading-tight">
              <h1 className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight text-[#0F1E33]">Zymerex Premi</h1>
              <div className="text-xs text-[#5A6B85] -mt-0.5">Gestionale promozioni & premi</div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-sm font-medium" data-testid="current-user-name">{user?.name}</span>
              <span className="flex items-center gap-1 text-xs text-[#0B6BCB]">
                <RoleIcon className="w-3 h-3" strokeWidth={1.5} /> {meta.label}
              </span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              className="text-[#5A6B85] hover:text-[#0F1E33] hover:bg-[#EEF4FC]"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4 mr-1.5" strokeWidth={1.5} /> Esci
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
